import EditorTimestamp from "@/components/Fields/EditorTimestamp.vue";
import EditorRegion from "@/components/Fields/EditorRegion.vue";
import EditorRelateid from "@/components/Fields/EditorRelateid.vue";
import EditorUpload from "@/components/Fields/EditorUpload.vue";
import EditorUploads from "@/components/Fields/EditorUploads.vue";
import EditorRichText from "@/components/Fields/EditorRichText.vue";
import EditorMeta from "@/components/Fields/EditorMeta.vue";
import EditorRelateArray from "@/components/Fields/EditorRelateArray.vue";
import EditorSimpleArray from "@/components/Fields/EditorSimpleArray.vue";
import BoolFilter from "@/components/Fields/BoolFilter.vue";

import CustomerInput from "@/widgets/Inputs/CustomerInput.vue";
import AdminInput from "@/widgets/Inputs/AdminInput.vue";
import Editor from "@/components/Editor.vue";
import FieldEditor from "@/components/FieldEditor.vue";
import FieldShow from "@/components/FieldShow.vue";
import InfoTable from "@/components/InfoTable.vue";

export default {
	Editor,
	FieldEditor,
	EditorRelateid,
	EditorRelateArray,
	EditorSimpleArray,
	CustomerInput,
	AdminInput,
	EditorUpload,
	EditorUploads,
	EditorRichText,
	EditorMeta,
	EditorTimestamp,
	EditorRegion,
	InfoTable,
	BoolFilter,
	FieldShow,
};
